import { ICategoryType } from '@wot/typings';
import xhr from '../utils/fetch';

const getCategoriesByType = async (type: ICategoryType) => {
  return await xhr({
    url: `/categories?type=${type}`,
    method: "GET",
  }).then((res) => res.data)
    .catch(err => { throw err })
};

const getTutorsByCategoryType = async (type: ICategoryType) => {
  return await xhr({
    url: `/tutors-count/${type}`,
    method: 'GET'
  }).then((res) => res.status === 'OK' && res.data)
    .catch((err) => err);
};

const getSearchResults = async (searchText: string) => {
  return await xhr({
    url: `/search/categories/${searchText}`,
    method: "GET",
  }).then((res) => res.data)
    .catch(err => { throw err })
}

const getPricing = async (categoryType: ICategoryType, params: any) => {
  return await xhr({
    url: `/pricing/${categoryType}`,
    method: 'GET',
    params: params
  }).then((res) => res.data)
    .catch((err) => { throw err });
}

const categoryApi = {
  getCategoriesByType,
  getTutorsByCategoryType,
  getSearchResults,
  getPricing
};

export default categoryApi;
